import { Modal } from "react-bootstrap";
import useStore from "../hooks/useStore";

export default function ProductListModal() {
  const {
    resultProductList,
    showProductListModal,
    setShowProductListModal,
    setSelectedPopularItem,
    setShowPopularItemModal,
  } = useStore();

  const handleSelectProduct = (product) => {
    setSelectedPopularItem(product);
    setShowPopularItemModal(true);
    setShowProductListModal(false);
  };

  const handleClose = () => setShowProductListModal(false);

  return (
    <Modal
      show={showProductListModal}
      onHide={handleClose}
      centered
      size="lg"
    >
      <Modal.Body className="px-5 text-center">
        <button
          type="button"
          className="btn-close"
          data-testid="product-list-modal-close-btn"
          onClick={handleClose}
        ></button>
        <div className="secondary-screen px-5">
          <div className="row text-center pt-5 pt-md-0 pb-3">
            <div className="col-md-8 m-auto pt-5 pt-md-0 ">
              <h3 className="py-2 fw-light">
                Product list <br />
                <b className="fw-bold">select the desired product</b>
              </h3>
            </div>
          </div>
          <div className="row justify-content-center">
            <div
              className="py-3 border d-block modalSearchedList mb-2"
              style={{ maxHeight: 600 }}
            >
              {resultProductList &&
                resultProductList.map((product, idx) => (
                  <div
                    className="row py-2 d-flex student justify-content-center"
                    role="button"
                    key={idx}
                  >
                    <div className="col-12 p-2 bg-white shadow-sm rounded-4 border d-flex">
                      <div className="col-9">
                        <p className="p-0 m-0 student-name">
                          <small
                            className="me-3"
                            style={{ verticalAlign: "middle" }}
                          >
                            #{product.id} ({product.type})
                          </small>
                          {product.name}{" "}
                          <small
                            className="ms-2"
                            style={{ verticalAlign: "middle" }}
                          >
                            ${product.price}
                          </small>
                        </p>
                        <p>
                          {product.color && (
                            <span className="badge rounded-pill bg-secondary text-white mx-2 fs-6">
                              {product.color}
                            </span>
                          )}
                          {product.size && (
                            <span className="badge rounded-pill bg-secondary text-white mx-2 fs-6">
                              {product.size}
                            </span>
                          )}
                        </p>
                      </div>
                      <div className="col-3 d-flex align-items-center justify-content-center">
                        <button
                          type="button"
                          className="btn btn-lg btn-outline-primary select-account-for-event checkout-btn"
                          data-testid="product-select-btn"
                          onClick={() => handleSelectProduct(product)}
                        >
                          Select
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
